<template>
  <div>
    <ChatModels />
  </div>
</template>

<script>
import ChatModels from "../pages/ChatModels/ChatModelsForm.vue";
export default {
  components: {
    ChatModels,
  },
};
</script>
